<div class="p-6">
  <!-- Header -->
  <div class="md:flex items-center justify-between mb-4">
    <h1 class="mb-2 md:mb-0 text-3xl text-gray-800">📚 Repository</h1>
    <mat-form-field class="w-full md:w-64">
      <mat-label>Search</mat-label>
      <input matInput (keyup)="applyFilter($event)" />
    </mat-form-field>
  </div>
  <!-- overflow-x-auto w-full table-container -->
  <div class="overflow-auto table-container">
    <table mat-table [dataSource]="dataSource" matSort class="w-full block">
      <!-- No -->
      <ng-container matColumnDef="no" [sticky]="true">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="px-3 py-2 bg-gray-50 text-sm font-semibold text-gray-600"
        >
          #
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          class="px-3 py-2 text-sm text-gray-700"
        >
          {{ element.no }}
        </td>
      </ng-container>

      <!-- Document -->
      <ng-container matColumnDef="document">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="px-3 py-2 bg-gray-50 text-sm font-semibold text-gray-600"
        >
          Document
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          class="px-3 py-2 text-sm font-medium text-gray-900"
        >
          {{ element.document }}
        </td>
      </ng-container>

      <!-- Publisher -->
      <ng-container matColumnDef="publisher">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="px-3 py-2 bg-gray-50 text-sm font-semibold text-gray-600"
        >
          Publisher
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          class="px-3 py-2 text-sm text-gray-700"
        >
          {{ element.publisher }}
        </td>
      </ng-container>

      <!-- Category -->
      <ng-container matColumnDef="category">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="px-3 py-2 bg-gray-50 text-sm font-semibold text-gray-600"
        >
          Category
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          class="px-3 py-2 text-sm text-gray-700"
        >
          {{ element.category }}
        </td>
      </ng-container>

      <!-- Edition -->
      <ng-container matColumnDef="edition">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="px-3 py-2 bg-gray-50 text-sm font-semibold text-gray-600"
        >
          Edition
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          class="px-3 py-2 text-sm text-gray-700"
        >
          {{ element.edition }}
        </td>
      </ng-container>

      <!-- Status -->
      <ng-container matColumnDef="status">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="px-3 py-2 bg-gray-50 text-sm font-semibold text-gray-600"
        >
          Status
        </th>
        <td mat-cell *matCellDef="let element" class="px-3 py-2">
          <span
            class="px-2 py-1 rounded-full text-xs font-medium"
            [class.bg-green-100]="element.status === 'In Use'"
            [class.text-green-700]="element.status === 'In Use'"
            [class.bg-gray-100]="element.status !== 'In Use'"
            [class.text-gray-600]="element.status !== 'In Use'"
          >
            {{ element.status }}
          </span>
        </td>
      </ng-container>

      <!-- Notes -->
      <ng-container matColumnDef="notes">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="px-3 py-2 bg-gray-50 text-sm font-semibold text-gray-600"
        >
          Aimi Notes
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          class="px-3 py-2 text-sm text-gray-700"
        >
          {{ element.notes }}
        </td>
      </ng-container>

      <!-- Remarks -->
      <ng-container matColumnDef="remarks">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="px-3 py-2 bg-gray-50 text-sm font-semibold text-gray-600"
        >
          Remarks
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          class="px-3 py-2 text-sm text-gray-700"
        >
          {{ element.remarks }}
        </td>
      </ng-container>

      <!-- Preview -->
      <ng-container matColumnDef="preview">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="px-3 py-2 bg-gray-50 text-sm font-semibold text-gray-600"
        >
          Preview
        </th>
        <td mat-cell *matCellDef="let element" class="px-3 py-2">
          @if (element.preview) {
            <a
              [href]="element.preview"
              target="_blank"
              class="text-primary-600 hover:underline font-medium"
            >
              Open
            </a>
          }
        </td>
      </ng-container>

      <!-- Render -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
